import { render, staticRenderFns } from "./cabinet-commercial-notice-card.vue?vue&type=template&id=379309b1&scoped=true&"
import script from "./cabinet-commercial-notice-card.vue?vue&type=script&lang=js&"
export * from "./cabinet-commercial-notice-card.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-commercial-notice-card.vue?vue&type=style&index=0&id=379309b1&scoped=true&lang=css&"
import style1 from "./cabinet-commercial-notice-card.vue?vue&type=style&index=1&id=379309b1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379309b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379309b1')) {
      api.createRecord('379309b1', component.options)
    } else {
      api.reload('379309b1', component.options)
    }
    module.hot.accept("./cabinet-commercial-notice-card.vue?vue&type=template&id=379309b1&scoped=true&", function () {
      api.rerender('379309b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/commercial/cards/cabinet-commercial-notice-card.vue"
export default component.exports